// removed by extract-text-webpack-plugin
module.exports = {"to-register-tip":"to-register-tip___mb9oi","tip-icon":"tip-icon___1mUPE","tip-desc":"tip-desc___3Z17z","tip-button":"tip-button___1zX44","tip-go-top":"tip-go-top___2bqMk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginBottomTip/index.modules.less
// module id = 756
// module chunks = 438